import { Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import dayjs from 'dayjs';

import { IProvider, IUnavailability } from '../../models/api/entities';
import { ITimetable } from '../../models/ITimetable';
import { minutesToTime } from '../../modules/utils/Utils';

interface Props {
    providers: IProvider[];
    timeTable: ITimetable;
    date: dayjs.Dayjs;
    unavailabilities: IUnavailability[];
}

const isBreakTime = (breakTimes, date, key) =>
    (breakTimes ?? []).filter((breakTime) => {
        if (parseInt(dayjs(date).format('d'), 10) !== breakTime.day) return false;
        const duration = 60;
        const slotStart = dayjs(date).startOf('day').set('minute', parseInt(key, 10));
        const slotEnd = slotStart.add(duration, 'minutes');

        const breakStart = dayjs(date).startOf('day').set('minute', breakTime.start);
        const breakEnd = dayjs(date).startOf('day').set('minute', breakTime.end);
        return slotStart.isBetween(breakStart, breakEnd, 'hours', '[)') || slotEnd.isBetween(breakStart, breakEnd, 'hours', '(]');
    }).length;

const isUnavailability = (unavailabilities, provider, date, key) =>
    (unavailabilities ?? []).filter((unavailability) => {
        if (provider.id !== unavailability.providerId) return false;
        const duration = 60;
        const slotStart = dayjs(date).startOf('day').set('minute', parseInt(key, 10));
        const slotEnd = slotStart.add(duration, 'minutes');

        const breakStart = dayjs(unavailability.startTime);
        const breakEnd = dayjs(unavailability.endTime);
        return slotStart.isBetween(breakStart, breakEnd, 'hours', '[)') || slotEnd.isBetween(breakStart, breakEnd, 'hours', '(]');
    }).length;

// TODO: Converting this into a utility function to add reusability
const Timetable = ({ providers, unavailabilities, timeTable, date }: Props) => {
    const theme = useTheme();
    return (
        <>
            <table style={{ width: '100%', borderSpacing: 0 }}>
                <thead>
                    <tr>
                        <th scope="col">
                            <Typography variant="h4">เวลา</Typography>
                        </th>
                        {providers.map((provider) => (
                            <th key={provider.id} scope="col">
                                <Typography variant="h4">{provider.name}</Typography>
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(timeTable).map((key) => (
                        <tr key={key} className="stripe">
                            <th scope="row">
                                <Typography variant="h4">{minutesToTime(parseInt(key, 10))}</Typography>
                            </th>
                            {providers.map((provider) => {
                                if (isUnavailability(unavailabilities, provider, date, key)) {
                                    return (
                                        // <td key={provider.id} style={{ backgroundColor: theme.palette.info.light }}>
                                        //     <Typography variant="h4" fontWeight={300} color="white" pl={1}>
                                        //         หยุด
                                        //     </Typography>
                                        // </td>
                                        <td key={provider.id} style={{ backgroundColor: theme.palette.warning.dark }}>
                                            <Typography variant="h4" fontWeight={300} color="white" pl={1}>
                                                ไม่รับ
                                            </Typography>
                                        </td>
                                    );
                                }
                                if (isBreakTime(provider.breakTimes, date, key)) {
                                    return (
                                        <td key={provider.id} style={{ backgroundColor: theme.palette.warning.dark }}>
                                            <Typography variant="h4" fontWeight={300} color="white" pl={1}>
                                                ไม่รับ
                                            </Typography>
                                        </td>
                                    );
                                }
                                if (timeTable[key].filter((i) => i.provider.id === provider.id).length) {
                                    return (
                                        <td key={provider.id} style={{ backgroundColor: theme.palette.error.main }}>
                                            <Typography variant="h4" fontWeight={300} color="white" pl={1}>
                                                จองแล้ว
                                            </Typography>
                                        </td>
                                    );
                                }
                                return (
                                    <td key={provider.id} style={{ padding: 3 }}>
                                        <Typography variant="h4" fontWeight={300} pl={1}>
                                            ว่าง
                                        </Typography>
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </>
    );
};

export default Timetable;
